module.exports = __webpack_public_path__ + "static/avatar_twixi_twins-7f3c14c75ebd0862c3b46bb1a43d331f.jpg";